/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createCandidateResume = /* GraphQL */ `mutation CreateCandidateResume(
  $input: CreateCandidateResumeInput!
  $condition: ModelCandidateResumeConditionInput
) {
  createCandidateResume(input: $input, condition: $condition) {
    id
    owner
    submitted
    verified
    ExperienceSummary {
      TotalYearsOfManagementWorkExperience
      TotalYearsOfLowLevelManagementWorkExperience
      TotalMonthsOfWorkExperience
      ExecutiveBrief
      TotalMonthsOfLowLevelManagementWorkExperience
      TotalMonthsOfManagementWorkExperience
      TotalYearsOfMidLevelManagementWorkExperience
      TotalMonthsOfMidLevelManagementWorkExperience
      TotalYearsOfSeniorManagementWorkExperience
      TotalMonthsOfSeniorManagementWorkExperience
      ManagementRecord
      HighestEducationalLevel
      TotalYearsOfWorkExperience
      __typename
    }
    Achievements
    Available
    Competency {
      skillLevel
      skillUsed {
        value
        type
        __typename
      }
      skillProficiency
      Grade
      skillName
      description
      auth
      skillCount
      lastUsed
      CompetencyId {
        idOwner
        id
        __typename
      }
      TaxonomyId {
        idOwner
        description
        __typename
      }
      skillAliasArray
      __typename
    }
    ContactMethod {
      InternetWebAddress {
        content
        type
        __typename
      }
      InternetEmailAddress_main
      InternetEmailAddress_alt
      Telephone_home
      Telephone_work
      Telephone_alt
      Telephone_mobile
      Pager
      Fax
      PostalAddress_main {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      PostalAddress_alt {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      __typename
    }
    DOB
    EducationHistory {
      StartDate
      EndDate
      MeasureValue
      Major
      SchoolUnit
      Degree {
        degreeType
        DegreeName
        DegreeDate
        __typename
      }
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      SchoolName
      schoolType
      Comments
      __typename
    }
    EmploymentHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    ExecutiveSummary
    Hobbies
    LicensesAndCertifications {
      IssuingAuthority {
        IssuingAuthorityName
        countryCode
        __typename
      }
      Id
      EffectiveDate {
        ValidFrom
        FirstIssuedDate
        ValidTo
        __typename
      }
      LicensesOrCertificationName
      Description
      __typename
    }
    Languages {
      CompetencyId {
        idOwner
        id
        __typename
      }
      Proficiency
      Speak
      LanguageCode
      Write
      Read
      __typename
    }
    lang
    LegalDocuments {
      IssueCountryCode
      IssueAuthority
      IssueDate
      Number
      IssueLocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      type
      __typename
    }
    MaritalStatus
    Nationality
    OtherInfo
    PersonName {
      FormattedName
      Title
      Suffix
      FamilyName
      GivenName
      PreferredGivenName
      MiddleName
      sex
      __typename
    }
    PlaceOfBirth {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    PoliticalStatus
    PreferredLocation
    PreferredPosition
    PreferredPositionType
    PreferredTypeOfHours
    ProjectHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    PublicationHistory {
      Comments
      content
      Issue
      JournalOrSerialName
      Volume
      PageNumber
      Name {
        FormattedName
        role
        __typename
      }
      Title
      PublicationDate
      __typename
    }
    Race
    References {
      CompanyName
      PersonName {
        FormattedName
        Title
        Suffix
        FamilyName
        GivenName
        PreferredGivenName
        MiddleName
        sex
        __typename
      }
      ContactMethod {
        InternetEmailAddress_main
        InternetEmailAddress_alt
        Telephone_home
        Telephone_work
        Telephone_alt
        Telephone_mobile
        Pager
        Fax
        __typename
      }
      PositionTitle
      __typename
    }
    RegisteredResidence {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    Religion
    RevisionDate
    Salary_desired {
      currency
      amount
      hiamount
      period
      __typename
    }
    Salary_current {
      currency
      amount
      hiamount
      period
      __typename
    }
    WillRelocate
    RawData
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCandidateResumeMutationVariables,
  APITypes.CreateCandidateResumeMutation
>;
export const updateCandidateResume = /* GraphQL */ `mutation UpdateCandidateResume(
  $input: UpdateCandidateResumeInput!
  $condition: ModelCandidateResumeConditionInput
) {
  updateCandidateResume(input: $input, condition: $condition) {
    id
    owner
    submitted
    verified
    ExperienceSummary {
      TotalYearsOfManagementWorkExperience
      TotalYearsOfLowLevelManagementWorkExperience
      TotalMonthsOfWorkExperience
      ExecutiveBrief
      TotalMonthsOfLowLevelManagementWorkExperience
      TotalMonthsOfManagementWorkExperience
      TotalYearsOfMidLevelManagementWorkExperience
      TotalMonthsOfMidLevelManagementWorkExperience
      TotalYearsOfSeniorManagementWorkExperience
      TotalMonthsOfSeniorManagementWorkExperience
      ManagementRecord
      HighestEducationalLevel
      TotalYearsOfWorkExperience
      __typename
    }
    Achievements
    Available
    Competency {
      skillLevel
      skillUsed {
        value
        type
        __typename
      }
      skillProficiency
      Grade
      skillName
      description
      auth
      skillCount
      lastUsed
      CompetencyId {
        idOwner
        id
        __typename
      }
      TaxonomyId {
        idOwner
        description
        __typename
      }
      skillAliasArray
      __typename
    }
    ContactMethod {
      InternetWebAddress {
        content
        type
        __typename
      }
      InternetEmailAddress_main
      InternetEmailAddress_alt
      Telephone_home
      Telephone_work
      Telephone_alt
      Telephone_mobile
      Pager
      Fax
      PostalAddress_main {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      PostalAddress_alt {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      __typename
    }
    DOB
    EducationHistory {
      StartDate
      EndDate
      MeasureValue
      Major
      SchoolUnit
      Degree {
        degreeType
        DegreeName
        DegreeDate
        __typename
      }
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      SchoolName
      schoolType
      Comments
      __typename
    }
    EmploymentHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    ExecutiveSummary
    Hobbies
    LicensesAndCertifications {
      IssuingAuthority {
        IssuingAuthorityName
        countryCode
        __typename
      }
      Id
      EffectiveDate {
        ValidFrom
        FirstIssuedDate
        ValidTo
        __typename
      }
      LicensesOrCertificationName
      Description
      __typename
    }
    Languages {
      CompetencyId {
        idOwner
        id
        __typename
      }
      Proficiency
      Speak
      LanguageCode
      Write
      Read
      __typename
    }
    lang
    LegalDocuments {
      IssueCountryCode
      IssueAuthority
      IssueDate
      Number
      IssueLocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      type
      __typename
    }
    MaritalStatus
    Nationality
    OtherInfo
    PersonName {
      FormattedName
      Title
      Suffix
      FamilyName
      GivenName
      PreferredGivenName
      MiddleName
      sex
      __typename
    }
    PlaceOfBirth {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    PoliticalStatus
    PreferredLocation
    PreferredPosition
    PreferredPositionType
    PreferredTypeOfHours
    ProjectHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    PublicationHistory {
      Comments
      content
      Issue
      JournalOrSerialName
      Volume
      PageNumber
      Name {
        FormattedName
        role
        __typename
      }
      Title
      PublicationDate
      __typename
    }
    Race
    References {
      CompanyName
      PersonName {
        FormattedName
        Title
        Suffix
        FamilyName
        GivenName
        PreferredGivenName
        MiddleName
        sex
        __typename
      }
      ContactMethod {
        InternetEmailAddress_main
        InternetEmailAddress_alt
        Telephone_home
        Telephone_work
        Telephone_alt
        Telephone_mobile
        Pager
        Fax
        __typename
      }
      PositionTitle
      __typename
    }
    RegisteredResidence {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    Religion
    RevisionDate
    Salary_desired {
      currency
      amount
      hiamount
      period
      __typename
    }
    Salary_current {
      currency
      amount
      hiamount
      period
      __typename
    }
    WillRelocate
    RawData
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCandidateResumeMutationVariables,
  APITypes.UpdateCandidateResumeMutation
>;
export const deleteCandidateResume = /* GraphQL */ `mutation DeleteCandidateResume(
  $input: DeleteCandidateResumeInput!
  $condition: ModelCandidateResumeConditionInput
) {
  deleteCandidateResume(input: $input, condition: $condition) {
    id
    owner
    submitted
    verified
    ExperienceSummary {
      TotalYearsOfManagementWorkExperience
      TotalYearsOfLowLevelManagementWorkExperience
      TotalMonthsOfWorkExperience
      ExecutiveBrief
      TotalMonthsOfLowLevelManagementWorkExperience
      TotalMonthsOfManagementWorkExperience
      TotalYearsOfMidLevelManagementWorkExperience
      TotalMonthsOfMidLevelManagementWorkExperience
      TotalYearsOfSeniorManagementWorkExperience
      TotalMonthsOfSeniorManagementWorkExperience
      ManagementRecord
      HighestEducationalLevel
      TotalYearsOfWorkExperience
      __typename
    }
    Achievements
    Available
    Competency {
      skillLevel
      skillUsed {
        value
        type
        __typename
      }
      skillProficiency
      Grade
      skillName
      description
      auth
      skillCount
      lastUsed
      CompetencyId {
        idOwner
        id
        __typename
      }
      TaxonomyId {
        idOwner
        description
        __typename
      }
      skillAliasArray
      __typename
    }
    ContactMethod {
      InternetWebAddress {
        content
        type
        __typename
      }
      InternetEmailAddress_main
      InternetEmailAddress_alt
      Telephone_home
      Telephone_work
      Telephone_alt
      Telephone_mobile
      Pager
      Fax
      PostalAddress_main {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      PostalAddress_alt {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      __typename
    }
    DOB
    EducationHistory {
      StartDate
      EndDate
      MeasureValue
      Major
      SchoolUnit
      Degree {
        degreeType
        DegreeName
        DegreeDate
        __typename
      }
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      SchoolName
      schoolType
      Comments
      __typename
    }
    EmploymentHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    ExecutiveSummary
    Hobbies
    LicensesAndCertifications {
      IssuingAuthority {
        IssuingAuthorityName
        countryCode
        __typename
      }
      Id
      EffectiveDate {
        ValidFrom
        FirstIssuedDate
        ValidTo
        __typename
      }
      LicensesOrCertificationName
      Description
      __typename
    }
    Languages {
      CompetencyId {
        idOwner
        id
        __typename
      }
      Proficiency
      Speak
      LanguageCode
      Write
      Read
      __typename
    }
    lang
    LegalDocuments {
      IssueCountryCode
      IssueAuthority
      IssueDate
      Number
      IssueLocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      type
      __typename
    }
    MaritalStatus
    Nationality
    OtherInfo
    PersonName {
      FormattedName
      Title
      Suffix
      FamilyName
      GivenName
      PreferredGivenName
      MiddleName
      sex
      __typename
    }
    PlaceOfBirth {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    PoliticalStatus
    PreferredLocation
    PreferredPosition
    PreferredPositionType
    PreferredTypeOfHours
    ProjectHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    PublicationHistory {
      Comments
      content
      Issue
      JournalOrSerialName
      Volume
      PageNumber
      Name {
        FormattedName
        role
        __typename
      }
      Title
      PublicationDate
      __typename
    }
    Race
    References {
      CompanyName
      PersonName {
        FormattedName
        Title
        Suffix
        FamilyName
        GivenName
        PreferredGivenName
        MiddleName
        sex
        __typename
      }
      ContactMethod {
        InternetEmailAddress_main
        InternetEmailAddress_alt
        Telephone_home
        Telephone_work
        Telephone_alt
        Telephone_mobile
        Pager
        Fax
        __typename
      }
      PositionTitle
      __typename
    }
    RegisteredResidence {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    Religion
    RevisionDate
    Salary_desired {
      currency
      amount
      hiamount
      period
      __typename
    }
    Salary_current {
      currency
      amount
      hiamount
      period
      __typename
    }
    WillRelocate
    RawData
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCandidateResumeMutationVariables,
  APITypes.DeleteCandidateResumeMutation
>;
export const createTimesheet = /* GraphQL */ `mutation CreateTimesheet(
  $input: CreateTimesheetInput!
  $condition: ModelTimesheetConditionInput
) {
  createTimesheet(input: $input, condition: $condition) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    contractId
    employeeId
    employeeName
    customerId
    customerName
    jobId
    status
    state
    submitted
    submittedBy
    submittedByName
    submittedDate
    approver1
    approver1Name
    approver1Token
    approved1
    approved1By
    approved1ByName
    approved1Date
    approver2
    approver2Name
    approver2Token
    approved2
    approved2By
    approved2ByName
    approved2Date
    fromDate
    toDate
    description
    entries {
      date
      type
      leaveType
      leaveId
      __typename
    }
    managersComments {
      date
      managerId
      message
      __typename
    }
    statusChanges {
      date
      userId
      status
      message
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTimesheetMutationVariables,
  APITypes.CreateTimesheetMutation
>;
export const deleteTimesheet = /* GraphQL */ `mutation DeleteTimesheet(
  $input: DeleteTimesheetInput!
  $condition: ModelTimesheetConditionInput
) {
  deleteTimesheet(input: $input, condition: $condition) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    contractId
    employeeId
    employeeName
    customerId
    customerName
    jobId
    status
    state
    submitted
    submittedBy
    submittedByName
    submittedDate
    approver1
    approver1Name
    approver1Token
    approved1
    approved1By
    approved1ByName
    approved1Date
    approver2
    approver2Name
    approver2Token
    approved2
    approved2By
    approved2ByName
    approved2Date
    fromDate
    toDate
    description
    entries {
      date
      type
      leaveType
      leaveId
      __typename
    }
    managersComments {
      date
      managerId
      message
      __typename
    }
    statusChanges {
      date
      userId
      status
      message
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTimesheetMutationVariables,
  APITypes.DeleteTimesheetMutation
>;
export const updateTimesheet = /* GraphQL */ `mutation UpdateTimesheet(
  $input: UpdateTimesheetInput!
  $condition: ModelTimesheetConditionInput
) {
  updateTimesheet(input: $input, condition: $condition) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    contractId
    employeeId
    employeeName
    customerId
    customerName
    jobId
    status
    state
    submitted
    submittedBy
    submittedByName
    submittedDate
    approver1
    approver1Name
    approver1Token
    approved1
    approved1By
    approved1ByName
    approved1Date
    approver2
    approver2Name
    approver2Token
    approved2
    approved2By
    approved2ByName
    approved2Date
    fromDate
    toDate
    description
    entries {
      date
      type
      leaveType
      leaveId
      __typename
    }
    managersComments {
      date
      managerId
      message
      __typename
    }
    statusChanges {
      date
      userId
      status
      message
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTimesheetMutationVariables,
  APITypes.UpdateTimesheetMutation
>;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    status
    date
    user
    template
    parameters
    timesheetId
    datePartition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    status
    date
    user
    template
    parameters
    timesheetId
    datePartition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    status
    date
    user
    template
    parameters
    timesheetId
    datePartition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const createRequest = /* GraphQL */ `mutation CreateRequest(
  $input: CreateRequestInput!
  $condition: ModelRequestConditionInput
) {
  createRequest(input: $input, condition: $condition) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    status
    type
    requestDate
    entityName
    notes
    drivingInstitureName
    emirate
    country
    dateFrom
    dateTo
    expectedAmount
    receivedAmount
    months
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRequestMutationVariables,
  APITypes.CreateRequestMutation
>;
export const deleteRequest = /* GraphQL */ `mutation DeleteRequest(
  $input: DeleteRequestInput!
  $condition: ModelRequestConditionInput
) {
  deleteRequest(input: $input, condition: $condition) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    status
    type
    requestDate
    entityName
    notes
    drivingInstitureName
    emirate
    country
    dateFrom
    dateTo
    expectedAmount
    receivedAmount
    months
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRequestMutationVariables,
  APITypes.DeleteRequestMutation
>;
export const updateRequest = /* GraphQL */ `mutation UpdateRequest(
  $input: UpdateRequestInput!
  $condition: ModelRequestConditionInput
) {
  updateRequest(input: $input, condition: $condition) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    status
    type
    requestDate
    entityName
    notes
    drivingInstitureName
    emirate
    country
    dateFrom
    dateTo
    expectedAmount
    receivedAmount
    months
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRequestMutationVariables,
  APITypes.UpdateRequestMutation
>;
export const createContractorActivity = /* GraphQL */ `mutation CreateContractorActivity(
  $input: CreateContractorActivityInput!
  $condition: ModelContractorActivityConditionInput
) {
  createContractorActivity(input: $input, condition: $condition) {
    id
    owner
    timesheetId
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    customerId
    customerName
    description
    assignedBy
    team
    status
    startDate
    endDate
    document
    createdAt
    updatedAt
    timesheet {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContractorActivityMutationVariables,
  APITypes.CreateContractorActivityMutation
>;
export const deleteContractorActivity = /* GraphQL */ `mutation DeleteContractorActivity(
  $input: DeleteContractorActivityInput!
  $condition: ModelContractorActivityConditionInput
) {
  deleteContractorActivity(input: $input, condition: $condition) {
    id
    owner
    timesheetId
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    customerId
    customerName
    description
    assignedBy
    team
    status
    startDate
    endDate
    document
    createdAt
    updatedAt
    timesheet {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContractorActivityMutationVariables,
  APITypes.DeleteContractorActivityMutation
>;
export const updateContractorActivity = /* GraphQL */ `mutation UpdateContractorActivity(
  $input: UpdateContractorActivityInput!
  $condition: ModelContractorActivityConditionInput
) {
  updateContractorActivity(input: $input, condition: $condition) {
    id
    owner
    timesheetId
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    customerId
    customerName
    description
    assignedBy
    team
    status
    startDate
    endDate
    document
    createdAt
    updatedAt
    timesheet {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContractorActivityMutationVariables,
  APITypes.UpdateContractorActivityMutation
>;
export const createDictionnary = /* GraphQL */ `mutation CreateDictionnary(
  $input: CreateDictionnaryInput!
  $condition: ModelDictionnaryConditionInput
) {
  createDictionnary(input: $input, condition: $condition) {
    id
    type
    value
    customerId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDictionnaryMutationVariables,
  APITypes.CreateDictionnaryMutation
>;
export const updateDictionnary = /* GraphQL */ `mutation UpdateDictionnary(
  $input: UpdateDictionnaryInput!
  $condition: ModelDictionnaryConditionInput
) {
  updateDictionnary(input: $input, condition: $condition) {
    id
    type
    value
    customerId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDictionnaryMutationVariables,
  APITypes.UpdateDictionnaryMutation
>;
export const deleteDictionnary = /* GraphQL */ `mutation DeleteDictionnary(
  $input: DeleteDictionnaryInput!
  $condition: ModelDictionnaryConditionInput
) {
  deleteDictionnary(input: $input, condition: $condition) {
    id
    type
    value
    customerId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDictionnaryMutationVariables,
  APITypes.DeleteDictionnaryMutation
>;
export const createFeatureFlag = /* GraphQL */ `mutation CreateFeatureFlag(
  $input: CreateFeatureFlagInput!
  $condition: ModelFeatureFlagConditionInput
) {
  createFeatureFlag(input: $input, condition: $condition) {
    id
    name
    category
    enabled
    condition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFeatureFlagMutationVariables,
  APITypes.CreateFeatureFlagMutation
>;
export const updateFeatureFlag = /* GraphQL */ `mutation UpdateFeatureFlag(
  $input: UpdateFeatureFlagInput!
  $condition: ModelFeatureFlagConditionInput
) {
  updateFeatureFlag(input: $input, condition: $condition) {
    id
    name
    category
    enabled
    condition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFeatureFlagMutationVariables,
  APITypes.UpdateFeatureFlagMutation
>;
export const deleteFeatureFlag = /* GraphQL */ `mutation DeleteFeatureFlag(
  $input: DeleteFeatureFlagInput!
  $condition: ModelFeatureFlagConditionInput
) {
  deleteFeatureFlag(input: $input, condition: $condition) {
    id
    name
    category
    enabled
    condition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFeatureFlagMutationVariables,
  APITypes.DeleteFeatureFlagMutation
>;
